import { GetPageInfoListResponse } from '../api-services/get-page-info-list.service';
import { GetPublishGoodsGroupSelectItemsResponse } from '../api-services/get-publish-goods-group-select-items.service';
import { GetTagListResponse } from '../api-services/get-tag-list.service';
import { KYMW4400Model } from '../kymw4400.model';
/**
 * ページ・台割編集画面のページ情報クラス
 *
 * @export PageInfo
 * @class PageInfo
 */
export class PageInfo {
  check = false;
  pageId: string;
  pageNum: string;
  folio: string;
  pageInfo: string;
  webCatalogTitle: string;
  pageTemplateId: string | null;
  contactUser1: string;
  contactUser2: string;
  contactUser3: string;
  feature1: string;
  feature2: string;
  feature3: string;
  autoArrangePattern: string;
  commonPublishFlg: string;
  publishGoodsGroupIdList: string[];
  publishGoodsGroupNameList: string[];
  tagIdList: string[];
  tagNameList: string[];
  isAutoArrangePatternRequired: boolean;

  constructor(data: GetPageInfoListResponse['PageList'][number] | string) {
    if (typeof data === 'string') {
      this.pageId = data;
      this.pageNum = '';
      this.folio = '';
      this.pageInfo = '';
      this.webCatalogTitle = '';
      this.pageTemplateId = KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT;
      this.contactUser1 = '';
      this.contactUser2 = '';
      this.contactUser3 = '';
      this.feature1 = '';
      this.feature2 = '';
      this.feature3 = '';
      this.autoArrangePattern = '';
      this.commonPublishFlg = '';
      this.publishGoodsGroupIdList = new Array();
      this.publishGoodsGroupNameList = new Array();
      this.tagIdList = new Array();
      this.tagNameList = new Array();
      this.isAutoArrangePatternRequired = this.pageTemplateId === KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT;
      return;
    }
    this.pageId = data.PageId;
    this.pageNum = data.PageNum;
    this.folio = data.Folio;
    this.pageInfo = data.PageInfo;
    this.webCatalogTitle = data.WebCatalogTitle;
    this.pageTemplateId = data.PageTemplateId;
    this.contactUser1 = data.ContactUser1;
    this.contactUser2 = data.ContactUser2;
    this.contactUser3 = data.ContactUser3;
    this.feature1 = data.Feature1;
    this.feature2 = data.Feature2;
    this.feature3 = data.Feature3;
    this.autoArrangePattern = data.AutoArrangePattern;
    this.commonPublishFlg = data.CommonPublishFlg;
    this.publishGoodsGroupIdList = data.PublishGoodsGroupIdList ?? new Array();
    this.publishGoodsGroupNameList = new Array();
    this.tagIdList = data.TagIdList ?? new Array();
    this.tagNameList = new Array();
    this.isAutoArrangePatternRequired = this.pageTemplateId === KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT;
  }

  public setPublishGoodsGroupName(
    data: GetPublishGoodsGroupSelectItemsResponse
  ) {
    this.publishGoodsGroupNameList = new Array();
    this.publishGoodsGroupIdList.forEach(_i => {
      const name = data.find(_d => _i === _d.Code)?.Name;
      if (name) this.publishGoodsGroupNameList.push(name);
    });
  }
  public setTagName(data: GetTagListResponse) {
    this.tagNameList = new Array();
    this.tagIdList.forEach(_i => {
      const name = data.find(_d => _i === _d.TagId)?.TagName;
      if (name) this.tagNameList.push(name);
    });
  }

  get dspPublishGoodsGroupNameList() {
    if (!this.publishGoodsGroupNameList) return '';
    return this.publishGoodsGroupNameList.join(',');
  }

  get dspTagNameList() {
    if (!this.tagNameList) return '';
    return this.tagNameList.join(',');
  }
}
